import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=f2386bf0&"
import script from "./SmallCard.vue?vue&type=script&lang=ts&"
export * from "./SmallCard.vue?vue&type=script&lang=ts&"
import style0 from "./SmallCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports